import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Trash2 } from "lucide-react"

interface ConfirmDeleteDialogProps {
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  trigger?: React.ReactNode
  children?: React.ReactNode
}

export function ConfirmDeleteDialog({
  title = "FAQ löschen",
  description = "Diese Aktion kann nicht rückgängig gemacht werden. Die FAQ wird dauerhaft gelöscht.",
  confirmText = "Löschen",
  cancelText = "Abbrechen",
  onConfirm,
  trigger,
  children,
}: ConfirmDeleteDialogProps) {
  const defaultTrigger = (
    <Button size="sm" variant="ghost">
      <Trash2 className="h-4 w-4 text-destructive" />
    </Button>
  )

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        {trigger || children || defaultTrigger}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-destructive" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            <Button variant="outline">
              {cancelText}
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            <Button variant="destructive">
              <Trash2 className="h-4 w-4 mr-2" />
              {confirmText}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}